import React from 'react'
// components
import Grid from '@mui/material/Grid2'
import { ReduxSwitch } from 'components/FormElements'
// view components
import Text from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Text'
import Lookup from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Lookup'
import MatrixField from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/MatrixField'
import DocumentOrLink from 'components/FormElements/DocumentOrLink/Risk'
// constants
import { Forms } from 'constants/forms'
// hooks
import { useFieldType } from 'hooks/risks'
// types
import { IField } from 'types/graphql'
// utils
import { generateFields } from 'utils/fields'

interface Props {
  name: string
  field: IField
}

const Field: React.FC<Props> = ({ field, name  }) => {
  const { isText, isNumber, isSwitch, isMatrix, isDocOrLink, isLookup } = useFieldType(field)

  if (isText || isNumber) {
    return <Text name={name} field={field} disabled />
  }

  if (isMatrix) {
    return <MatrixField isTable field={field} name={name} required={field.required} isDisabled />
  }

  if (isDocOrLink) {
    return <DocumentOrLink field={field} name={name} required={field.required} isDisabled />
  }

  if (isSwitch) {
    return (
      <Grid key={field.id} className='switch-wrapper'>
        <ReduxSwitch name={name} label={field.label} required={field.required} disabled />
      </Grid>
    )
  }

  if (isLookup) {
    return <Lookup name={name} field={field} disabled />
  }

  return (
    <>
      {generateFields({
        canModify: false,
        shouldValidate: false,
        field: { ...field, name },
        form: Forms.RISK_TEMPLATE_FORM,
      })}
    </>
  )
}

export default Field
